import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { GuideSection } from '../core'
import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { RADIUS } from '@/shared/styles/radii'
import { FONT_WEIGHT, typeScale } from '@/shared/styles/typography'

type GuideRouterProps = {
  sections: GuideSection[]
}

/**
 * 冒頭の区分ルーター。区分記号（A〜D）を持つ節だけを並べる。
 * 紙のQR/URLから来た人が、最初の1画面で自分の見るところを特定できるようにする。
 *
 * 枠で囲わない (罫線は最後の手段)。行であることは hover 塗りだけで示す。
 */
export const GuideRouter: FC<GuideRouterProps> = ({ sections }) => (
  <Box sx={{ mt: 2, mb: 5 }}>
    {sections
      .filter((s) => Boolean(s.label))
      .map((s) => (
        <Box
          key={s.id}
          component="a"
          href={`#${s.id}`}
          sx={{
            display: 'flex',
            gap: 2,
            px: 1.5,
            py: 1,
            borderRadius: `${RADIUS.lg}px`,
            textDecoration: 'none',
            color: colorTokens.fg.default,
            '&:hover': { backgroundColor: colorTokens.overlay.hover },
          }}
        >
          <Typography
            component="span"
            sx={{
              ...typeScale.body,
              fontWeight: FONT_WEIGHT.semibold,
              color: colorTokens.fg.muted,
              width: 16,
              flexShrink: 0,
            }}
          >
            {s.label}
          </Typography>
          <Typography component="span" sx={typeScale.body}>
            {s.title}
          </Typography>
        </Box>
      ))}
  </Box>
)
